<template>
    <div>

        <div class="columns" v-if="groupType == 'master'">

            <div class="column">

                <b-field
                    expanded
                    label="Магистерская программа">
                    <b-select
                        expanded
                        @input="onMasterProgramChange"
                        placeholder="Любая программа"
                        v-model="subjectFilter.details.masterProgram">
                        <option :value="null">Любая программа</option>
                        <option
                            v-for="program in masterPrograms"
                            :value="program"
                            :key="program.id">
                            {{ program.name }}
                        </option>
                    </b-select>
                </b-field>

            </div>
            
        </div>

        <div class="columns" v-if="linguisticGroup">

            <div class="column">

                <b-field
                    expanded
                    class="required"
                    label="Язык">
                    <b-select
                        :placeholder="filterSubjects(subjects).length > 0 ?
                        'Выберите язык' : 'Нет языков данного типа'"
                        @input="onLanguageChange"
                        expanded
                        v-model="item.subject"
                        :disabled="filterSubjects(subjects).length == 0">
                        <option disabled>Выберите язык</option>
                        <option
                            v-for="option in filterSubjects(subjects)"
                            :value="option.id"
                            :key="option.id">
                            {{ option.title }}
                        </option>
                    </b-select>
                </b-field>

            </div>

            <div class="column">

                <b-field
                    expanded
                    :label="$t(`schedule.classtime`)">
                    <b-select
                        @input="modify"
                        expanded
                        :placeholder="classtimes.length > 0 ?
                        'Выберите время занятий' : 'Нет доступных времен занятий'"
                        :disabled="classtimes.length == 0"
                        v-model="item.classtime">
                        <option
                            v-for="option in classtimes"
                            :value="option.id"
                            :key="option.id">
                            {{ option.name }}
                            ({{ option.start }})
                        </option>
                    </b-select>
                </b-field>

            </div>

        </div>
        
        <div class="columns" v-else>

            <div class="column" v-if="groupType == 'bachelor' || groupType == 'optional'">

                <b-field
                    expanded
                    label="Кафедра">
                    <b-select
                        expanded
                        @input="onSubjectTypeChange"
                        placeholder="Без кафедры"
                        v-model="subjectFilter.details.department">
                        <option :value="null">Без кафедры</option>
                        <option
                            v-for="department in filterDepartments(departments)"
                            :value="department"
                            :key="department.id">
                            {{ department.name }}
                        </option>
                    </b-select>
                </b-field>

            </div>

            <div class="column" v-else>

                <b-field
                    expanded
                    :label="$t(`schedule.subject_type`)">
                    <b-select
                        @input="onSubjectTypeChange"
                        expanded
                        :disabled="groupType == 'master' && subjectFilter.details.masterProgram"
                        v-model="subjectFilter.details.type">
                        <option
                            v-for="option in subjectFilter.details.typeList"
                            :value="option"
                            :key="option">
                            {{ $t('subjects.details.' + option) }}
                        </option>
                    </b-select>
                </b-field>

            </div>

            <div class="column">

                <b-field
                    expanded
                    class="required"
                    :label="$t(`schedule.subject`)">
                    <b-select
                        :placeholder="filterSubjects(subjects).length > 0 ?
                        'Выберите дисциплину' : 'В данной категории нет дисциплин'"
                        @input="onSubjectChange"
                        expanded
                        v-model="item.subject"
                        :disabled="filterSubjects(subjects).length == 0">
                        <option disabled>Выберите дисциплину</option>
                        <option
                            v-for="option in filterSubjects(subjects)"
                            :value="option.id"
                            :key="option.id">
                            {{ option.title }}
                            <template v-if="$_.get(option, 'details.linguistic')">
                                ({{
                                    $t('subjects.main.linguistic.' +
                                    $_.get(option, 'details.linguistic'))
                                }})
                            </template>
                            <template v-else-if="$_.get(option, 'details.optional')">
                                (Курс по выбору)
                            </template>
                        </option>
                    </b-select>
                </b-field>

            </div>

        </div>

        <div class="columns" v-if="groupType != 'optional'">

            <div class="column">

                <b-field
                    expanded
                    class="required"
                    :label="$t(`schedule.groups`)">
                    <b-field
                        grouped
                        group-multiline
                        expanded>
                        <template v-if="filteredGroups(groups).length > 0">
                            <div class="control"
                                v-for="option in filteredGroups(groups)"
                                :key="option.id">
                                <b-checkbox
                                    @input="modify"
                                    v-model="item.groups"
                                    :disabled="checkGroup(option)"
                                    :native-value="option.id">
                                    <template v-if="linguisticGroup">
                                        {{ option.details.number }}
                                    </template>
                                    <template v-else>
                                        {{ option.title }}
                                    </template>
                                </b-checkbox>
                            </div>
                            <div class="control"
                                v-if="!subjectFilter.details.masterProgram &&
                                      !subjectFilter.details.department">
                                <b-checkbox
                                    v-model="allGroupsChecked">
                                    Отметить все
                                </b-checkbox>
                            </div>
                        </template>
                        <template v-else>
                            <p>Нет доступных групп</p>
                        </template>
                    </b-field>
                </b-field>

            </div>

        </div>

        <div class="columns">

            <div class="column">

                <b-field
                    expanded
                    :label="$t(`schedule.parity`)">

                    <b-field>

                        <b-checkbox
                            @input="modify"
                            v-model="item.parity"
                            true-value="alternating"
                            false-value="both">
                            <span>Раз в 2 недели</span>
                        </b-checkbox>

                    </b-field>

                </b-field>

            </div>

            <div class="column" v-if="!linguisticGroup">

                <b-field
                    expanded
                    :label="$t(`schedule.classtime`)">
                    <b-select
                        @input="modify"
                        expanded
                        :placeholder="classtimes.length > 0 ?
                        'Выберите время занятий' : 'Нет доступных времен занятий'"
                        :disabled="classtimes.length == 0"
                        v-model="item.classtime">
                        <option
                            v-for="option in classtimes"
                            :value="option.id"
                            :key="option.id">
                            {{ option.name }}
                            ({{ option.start }})
                        </option>
                    </b-select>
                </b-field>

            </div>

        </div>

        <div class="columns">

            <div class="column">

                <b-field
                    expanded
                    :class="{ required: linguisticGroup != null }"
                    :label="$t(`schedule.classroom`)">
                    <b-select
                        :placeholder="classrooms.length > 0 ?
                        'Не указана' : 'Нет доступных аудиторий'"
                        :disabled="classrooms.length == 0"
                        @input="modify"
                        expanded
                        v-model="item.classroom">
                        <option :value="null">Не указана</option>
                        <option
                            v-for="option in classrooms"
                            :value="option.id"
                            :key="option.id">
                            {{ option.name }}
                        </option>
                    </b-select>
                </b-field>

            </div>

            <div class="column">

                <b-field
                    expanded
                    :label="$t(`schedule.teacher`)">
                    <b-select
                        :disabled="teachers.length == 0"
                        :placeholder="teachers.length > 0 ?
                        'Не указан' : 'Нет преподавателей'"
                        @input="modify"
                        expanded
                        v-model="item.teacher">
                        <option :value="null">Не указан</option>
                        <option
                            v-for="option in teachers"
                            :value="option.id"
                            :key="option.id">
                            {{ option.full_name }}
                            <template v-if="option.type === 'employee'">
                            ({{ $_.get(option.profile, 'position.name') }})
                            </template>
                            <template v-else>
            ({{ $t(`users.profile.type.${$_.get(option.profile, 'type')}`) }})
                            </template>
                        </option>
                    </b-select>
                </b-field>

            </div>

        </div>

        <div class="columns">
            <div class="column">
                <b-field
                    expanded
                    label="Совместитель">
                    <b-input
                        @input="modify"
                        placeholder="Фамилия Имя Отчество"
                        v-model="item.extra_teacher">
                    </b-input>
                </b-field>
            </div>
        </div>

        <div class="columns">

            <b-collapse class="column" :open="true">

                <div
                    expanded
                    class="button is-primary is-fullwidth"
                    :class="{
                        'is-outlined': !props.open
                    }"
                    slot="trigger"
                    slot-scope="props">
                    <span>
                        {{ $t(`schedule.begin_at`) }}
                        ({{ item.begin_at | moment("dddd, Do MMMM YYYY") }})
                    </span>
                    <b-icon
                        :icon="props.open ? 'menu-down' : 'menu-up'">
                    </b-icon>
                </div>

                <b-field class="card-content" expanded>
                    <calendar
                        @input="modify"
                        v-model="item.begin_at"
                        :min-date="minDate"
                        :max-date="maxDate"
                        :academic-year-start="academicYearStart"
                    ></calendar>
                </b-field>

            </b-collapse>

        </div>
    </div>
</template>
<script>
export default Vue.extend({
  props: {
    preset: [Object],
    schedule: {
      type: Object,
      required: true
    },
    studentType: {
      type: String,
      required: true
    },
    departments: {
      type: Array,
      required: true
    },
    masterPrograms: {
      type: Array,
      required: true
    },
    subjects: {
      type: Array,
      required: true
    },
    groups: {
      type: Array,
      required: true
    },
    classrooms: {
      type: Array,
      required: true
    },
    classtimes: {
      type: Array,
      required: true
    },
    semesterRange: {
      type: Object,
      required: true
    },
    groupType: {
      type: String,
      default: "regular"
    },
    academicYearStart: {
      type: Date
    }
  },
  data() {
    return {
      item: {
        subject: null,
        teacher: null,
        groups: [],
        classroom: null,
        classtime: null,
        parity: "both",
        begin_at: null,
        class_type: "lecture" // from subjectFilter.details.typeList
      },
      subjectFilter: {
        type: "main",
        typeList: ["main", "department", "generic"],
        details: {
          type: "lecture",
          department: null,
          masterProgram: null,
          typeList: ["lecture", "seminar", "practice"]
        }
      }
    };
  },
  created() {
    this.item.begin_at = this.minDate;
    this.item.classtime = _.get(_.first(this.classtimes), "id");
    if (this.preset) {
      // Convert entry entity to form data object
      let subject = this.preset.subject;

      if (subject && subject.type == "department") {
        this.subjectFilter.type = "department";
        switch (subject.student_type) {
          case "bachelor": {
            this.subjectFilter.details.department = _.find(this.departments, {
              id: _.get(subject.details, "department.id")
            });
            break;
          }
          case "master": {
            this.subjectFilter.details.masterProgram = _.find(
              this.masterPrograms,
              {
                department: {
                  id: _.get(subject.details, "department.id")
                }
              }
            );
            break;
          }
        }
      } else {
        this.subjectFilter.type = "main";
        this.subjectFilter.details.type = _.get(
          this.preset,
          "class_type",
          this.item.class_type
        );
      }

      if (this.preset.subject) {
        this.preset.subject = this.preset.subject.id;
      }

      this.preset.groups = _.map(this.preset.groups, "id");
      this.preset.classtime = this.preset.classtime.id;
      if (this.preset.classroom) {
        this.preset.classroom = this.preset.classroom.id;
      }
      if (this.preset.teacher) {
        this.preset.teacher = this.preset.teacher.id;
      }
      if (this.preset.extra_teacher) {
        this.preset.extra_teacher = this.preset.extra_teacher.full_name;
      }
      this.preset.begin_at = this.$moment(this.preset.begin_at).toDate();

      if (this.preset.parity) {
        this.preset.parity =
          this.preset.parity == "both" ? "both" : "alternating";
      }

      this.item = _.merge(this.item, this.preset);
    }
  },
  computed: {
    linguisticGroup() {
      if (
        this.groupType == "linguistic-primary" ||
        this.groupType == "linguistic-secondary"
      ) {
        return this.groupType == "linguistic-primary" ? "primary" : "secondary";
      } else {
        return null;
      }
    },
    minDate() {
      return this.$moment(this.semesterRange.start.date).toDate();
    },
    maxDate() {
      return this.$moment(this.semesterRange.end.date).toDate();
    },
    allGroupsChecked: {
      get() {
        let groups = this.filteredGroups(this.groups);
        return _.difference(_.map(groups, "id"), this.item.groups).length == 0;
      },
      set(value) {
        let groups = _.map(this.filteredGroups(this.groups), "id");

        if (value) {
          this.item.groups = [];
          _.each(groups, group => {
            this.item.groups.push(group);
          });
        } else {
          if (groups.length == this.item.groups.length) {
            this.item.groups = [];
          }
        }
        this.modify();
      }
    },
    teachers() {
      let subject = _.find(this.subjects, { id: this.item.subject });
      if (subject) {
        return subject.teachers;
      }
      return [];
    }
  },
  methods: {
    onSubjectTypeChange(type) {
      this.item.subject = null;
      if (this.groupType == "bachelor") {
        this.item.class_type = "practice";
        this.subjectFilter.type = "department";
        this.item.groups = [];
      } else {
        this.item.class_type = type;
        this.subjectFilter.type = "main";
      }
    },
    onMasterProgramChange(program) {
      this.item.subject = null;
      if (this.subjectFilter.details.masterProgram) {
        this.item.groups = _.map(
          _.filter(this.groups, group => {
            return (
              this.subjectFilter.details.masterProgram.id ==
              _.get(group.details, "program.id")
            );
          }),
          "id"
        );
      } else {
        this.item.groups = [];
      }
    },
    onSubjectChange(id) {
      this.item.teacher = null;

      if (this.groupType == 'optional') {
        let group = _.find(this.groups, {
          type: 'optional',
          details: {
            subject: {
              id: id,
            },
          },
        });

        this.item.class_type = 'practice';

        this.item.groups = [
          group ? group.id : null
        ];
      }

      this.modify();
    },
    onLanguageChange() {
      this.item.groups.splice(0, this.item.groups.length);
      this.onSubjectChange();
    },
    filterDepartments(departments) {
      switch (this.groupType) {
        case "optional": {
          let filteredSubjects = _.map(
            _.map(
              _.filter(this.groups, { type: 'optional' }),
              group => _.get(group, 'details.subject.id')
            ),
            id => {
              return _.find(this.subjects, { id });
            }
          ).filter(item => item !== undefined)

          filteredSubjects = _.omitBy(filteredSubjects, (subject) => {
            return !_.has(subject, "details.department");
          });

          return _.uniqBy(
            _.map(filteredSubjects, subject => {
              return _.get(subject, 'details.department');
            }),
            'id'
          );
        }
        default: {
          return departments;
        }
      }
    },
    filterSubjects(subjects) {

      let genericFilter = subjects => {
        return _.filter(subjects, subject => {
          let expression = !_.get(subject, "details.linguistic");

          switch (this.subjectFilter.details.type) {
            case "lecture": {
              expression =
                expression &&
                subject.type == "main" &&
                _.get(subject, "details.lecture");
              break;
            }
            case "seminar": {
              expression =
                expression &&
                subject.type == "main" &&
                _.get(subject, "details.seminar");
              break;
            }
            case "practice": {
              expression =
                expression &&
                (subject.type == "main" || subject.type == "generic") &&
                !_.get(subject, "details.lecture") &&
                !_.get(subject, "details.seminar");
              break;
            }
          }

          return expression;
        });
      };

      switch (this.groupType) {
        case "linguistic-primary":
        case "linguistic-secondary": {
          return _.filter(subjects, subject => {
            return _.get(subject, "details.linguistic") == this.linguisticGroup;
          });
        }
        case "master": {
          if (this.subjectFilter.details.masterProgram) {
            return _.filter(subjects, subject => {
              return (
                subject.student_type == this.groupType &&
                subject.type == "department" &&
                _.get(subject, "details.department.id") ==
                  _.get(
                    this.subjectFilter.details,
                    "masterProgram.department.id"
                  )
              );
            });
          } else {
            return genericFilter(subjects);
          }
        }
        case "bachelor": {
          if (!this.subjectFilter.details.department) {
            return [];
          }

          return _.filter(subjects, subject => {
            return (
              subject.type == "department" &&
              subject.student_type == this.groupType &&
              _.get(subject, "details.department.id") ==
                _.get(this.subjectFilter.details, "department.id")
            );
          });
        }
        case "optional": {
          let filter = {
            type: "optional",
          };

          if (_.get(this.subjectFilter, "details.department.id")) {
            filter = Object.assign(
              {
                details: {
                  subject: {
                    details: {
                      department: {
                        id: _.get(this.subjectFilter, "details.department.id"),
                      },
                    },
                  },
                },
              },
              filter
            );
          } else {
            filter = Object.assign(
              {
                details: {
                  subject: {
                    type: "main",
                  },
                },
              },
              filter
            );
          }

          let filteredSubjects = _.map(
            _.map(
              _.filter(this.groups, filter),
              group => _.get(group, 'details.subject.id')
            ),
            id => {
              return _.find(this.subjects, { id });
            }
          ).filter(item => item !== undefined)

          return filteredSubjects;
        }
        default: {
          return genericFilter(subjects);
        }
      }
    },
    filteredGroups(groups) {
      switch (this.groupType) {
        case "linguistic-primary":
        case "linguistic-secondary": {
          return _.filter(groups, group => {
            return (
              group.student_type == this.studentType &&
              group.type == "linguistic" &&
              group.details.subject.id == this.item.subject
            );
          });
        }
        default: {
          return _.filter(groups, group => {
            return (
              group.student_type == this.studentType &&
              group.type == this.groupType
            );
          });
        }
      }
    },
    checkGroup(group) {
      let available = true;
      let groups = this.item.groups;

      switch (this.groupType) {
        case "master": {
          available = !this.subjectFilter.details.masterProgram;
          //   available =
          //     _.get(group.details, "program.id") ==
          //     _.get(this.subjectFilter.details, "masterProgram.id");
          break;
        }
        case "bachelor": {
          if (this.subjectFilter.details.department) {
            available =
              _.get(group.details, "department.id") ==
              this.subjectFilter.details.department.id;
          }
          break;
        }
      }

      return !available;
    },
    modify() {
      this.$emit("modified", this.item);
    },
    save: function() {
      return new Promise((resolve, reject) => {
        let data = _.clone(this.item);

        let date = this.$moment(data.begin_at).format("YYYY-MM-DD");
        data.begin_at = date;

        data.schedule = this.schedule.id;

        // Update if item id is filled
        if (data.id) {
          axios
            .put(`/api/schedule/${this.schedule.id}/entry/${data.id}`, data)
            .then(response => {
              resolve({ entry: response.data, fresh: false });
            })
            .catch(error => {
              reject(error);
            });
        } else {
          axios
            .post(`/api/schedule/${this.schedule.id}/entry`, data)
            .then(response => {
              resolve({ entry: response.data, fresh: true });
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },
    delete: function() {
      return new Promise((resolve, reject) => {
        let id = this.item.id;

        if (id) {
          axios
            .delete(`/api/schedule/${this.schedule.id}/entry/${id}`)
            .then(response => {
              resolve(id);
            })
            .catch(error => {
              reject();
            });
        } else {
          reject();
        }
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/models/ScheduleEntry.vue